/* Cleco Kit Builder — resume a saved kit from anywhere on the site.
 *
 * Saved kits live in localStorage on the customer's own device. Off the
 * builder page nothing could read them, so a saved kit was invisible the
 * moment you left — and worse, every promo placement links with ?new=1,
 * which deliberately starts a FRESH kit. So a customer with a half-built kit
 * was being invited to throw it away by the very thing meant to bring them
 * back.
 *
 * ⚠ It changes TWO things and nothing else: the link, and the button label.
 * An earlier pass also rewrote the eyebrow, heading and body — Owen's call
 * (2026-09-05) was to leave the block exactly as it reads normally, so the
 * promo still says what it is and only the action changes.
 *
 * The label is rendered by Liquid into a data- attribute on the promo
 * (snippets/wb-kb-promo.liquid) — a sitewide script cannot call the `t`
 * filter, and hardcoding English here would ship untranslated to 20 markets.
 */
(function () {
  'use strict';

  var KEY = 'wb-kb-shelf-v1';

  function newestKit() {
    var raw;
    /* Private mode throws on access, not on read — and a corrupt shelf is not
       worth breaking a page over. Either way the promos stay as they are. */
    try { raw = window.localStorage.getItem(KEY); } catch (e) { return null; }
    if (!raw) return null;
    var kits;
    try {
      var d = JSON.parse(raw);
      kits = (d && Object.prototype.toString.call(d.kits) === '[object Array]') ? d.kits : [];
    } catch (e) { return null; }
    var best = null;
    for (var i = 0; i < kits.length; i++) {
      var k = kits[i];
      if (!k || !k.id || !(k.pieces > 0)) continue;
      if (!best || (k.savedAt || 0) > (best.savedAt || 0)) best = k;
    }
    return best;
  }

  function setText(root, sel, txt) {
    if (!txt) return;
    var el = root.querySelector(sel);
    if (el) el.textContent = txt;
  }

  function apply(kit) {
    var nodes = document.querySelectorAll('[data-kbp-resume]:not([data-kbp-done])');
    for (var n = 0; n < nodes.length; n++) {
      var el = nodes[n];
      el.setAttribute('data-kbp-done', '');
      var base = el.getAttribute('data-kbp-base');
      if (!base) continue;

      /* ⚠ Built from data-kbp-base, the CLEAN builder URL, never from the
         rendered href — that one carries ?new=1 and would wipe the kit. */
      var href = base + (base.indexOf('?') >= 0 ? '&' : '?') +
        'open=' + encodeURIComponent(kit.id);

      if (el.tagName === 'A') el.setAttribute('href', href);
      else {
        var a = el.querySelector('a[href]');
        if (a) a.setAttribute('href', href);
      }

      el.classList.add('is-resume');

      /* The chip is one word in one element — nothing to walk. */
      if (el.hasAttribute('data-kbp-chip')) {
        var c = el.getAttribute('data-kbp-cta');
        if (c) el.textContent = c;
        continue;
      }

      /* The label only. The block's own words are left alone on purpose. */
      setText(el, '.wb-kbp__ctatxt', el.getAttribute('data-kbp-cta'));
    }
  }

  function run() {
    var kit = newestKit();
    if (!kit) return;
    apply(kit);
  }

  function boot() {
    /* The builder has its own Saved Kits panel in its masthead. */
    if (document.querySelector('[data-wb-kb-config]')) return;

    run();

    /* ⚠ Predictive search rebuilds its whole panel from the server on every
       keystroke, so its promo row is a brand new element each time and would
       keep offering a fresh start. Watch for promos that appear later and
       treat them the same. Debounced, and each node is done once. */
    if (window.MutationObserver && document.body) {
      var t = null;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(run, 60);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  /* ⚠ This is loaded from the HEAD without defer, alongside the other WB
     head scripts, so at execution time there is no <body> yet: querySelector
     found nothing and the observer had nothing to observe. Wait for the DOM
     rather than moving the tag, which would change load order for the rest. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
